import service from '@/utils/https.js';

export function generateUploadUrl(data = {}) {
  return service({
    url: '/uploadFile/generateUploadUrl',
    method: 'post',
    data,
  });
}
